import menuIcon from '@iconify/icons-heroicons-outline/menu';
import React, { FC } from 'react';
import { Link } from 'react-router-dom';

import { BFILogoHorizontal } from '@assets/images/svg';
import MemoizedIcon from '@components/MemoizedIcon';
import useMediaQuery from '@hooks/useMediaQuery';
import { MAX_WIDTH_SM } from '@src/constants';

import UserProfileSection from './UserProfileSection';

type Props = {
  openSidebar: () => void;
};

const Header: FC<Props> = ({ openSidebar }) => {
  const isMobile = useMediaQuery(MAX_WIDTH_SM);

  return (
    <div className="bg-white sm:rounded-none h-[67px] sm:h-[77px] fixed w-full z-50 shadow-[0_1px_4px_rgba(0,0,0,0.08)]">
      <nav className="h-full">
        <div className="mx-auto px-4 sm:px-4 lg:px-6 h-full">
          <div className="flex items-center justify-between h-full w-full relative">
            <button
              data-testid="btn-open-sidebar"
              onClick={() => {
                openSidebar();
              }}
            >
              <MemoizedIcon icon={menuIcon} className="h-6 w-6" />
            </button>
            <div className="flex items-center absolute left-1/2 -translate-x-1/2">
              <Link to="/">
                <img
                  src={BFILogoHorizontal}
                  alt="BFILogoHorizontal"
                  width={123}
                  height={35}
                />
              </Link>
            </div>
            {!isMobile && (
              <div className="flex items-center">
                <UserProfileSection />
              </div>
            )}
          </div>
        </div>
      </nav>
    </div>
  );
};

export default Header;
